import { MenuItem, Select, FormControl } from "@material-ui/core";
import { DateRange } from "@material-ui/icons";
import styled from "styled-components";

export default function RuleThree({value, onChange, errors, touched}) {
    return (
        <RuleContainer>
            <RuleDescription>
                <DateRange style={{ fontSize: '16px', marginRight: '6px', color: '#667eea' }} />
                Dia da Semana
            </RuleDescription>
            <StyledFormControl fullWidth variant="outlined">
                <StyledSelect
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                >
                    <MenuItem value={1}>Segunda</MenuItem>
                    <MenuItem value={2}>Terça</MenuItem>
                    <MenuItem value={3}>Quarta</MenuItem>
                    <MenuItem value={4}>Quinta</MenuItem>
                    <MenuItem value={5}>Sexta</MenuItem>
                </StyledSelect>
            </StyledFormControl>
        </RuleContainer>
    )
}

const RuleContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const RuleDescription = styled.p`
    font-size: 13px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
    display: flex;
    align-items: center;
    font-family: 'Mulish', sans-serif;
`;

const StyledFormControl = styled(FormControl)`
    .MuiOutlinedInput-root {
        border-radius: 10px;
        background: white;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
        }

        &.Mui-focused {
            box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
        }
    }

    .MuiOutlinedInput-input {
        font-family: 'Mulish', sans-serif;
        font-size: 14px;
    }
`;

const StyledSelect = styled(Select)`
    font-family: 'Mulish', sans-serif;
`;